
// const fileBaseUrl = 'http://10.64.81.47:8776' //附件相关 高

const fileBaseUrl = '/api' //附件相关 测试

// const fileBaseUrl = 'http://10.64.81.66:8776' //附件相关 杨

// const fileBaseUrl = 'http://10.64.81.51:8776' //附件相关 黄

export default {
  fileBaseUrl,
}